<template>
  <div id="aiFace" ref="aiFace">

    <div class="camera_outer">
   
      <div class="camera-box">

        <div class="people-outline">
          <svg width="100%" height="100%" viewBox="0 0 300 400" preserveAspectRatio="xMidYMid meet" ref="peopleOutlineImg">
            <defs>
              <mask id="teacher-face-mask">
                <rect width="100%" height="100%" fill="white" />
                <path d="M 150 40 C 110 40, 70 72, 50 136 C 30 200, 60 296, 90 336 C 110 356, 130 360, 150 360 C 170 360, 190 356, 210 336 C 240 296, 270 200, 250 136 C 230 72, 190 40, 150 40 Z" fill="black" />
              </mask>
            </defs>
            <rect width="100%" height="100%" fill="rgba(0, 0, 0, 0.8)" mask="url(#teacher-face-mask)" />
            <path d="M 150 40 C 110 40, 70 72, 50 136 C 30 200, 60 296, 90 336 C 110 356, 130 360, 150 360 C 170 360, 190 356, 210 336 C 240 296, 270 200, 250 136 C 230 72, 190 40, 150 40 Z" fill="none" stroke="#2dcc00" stroke-width="2" stroke-dasharray="6,4" opacity="1" />
          </svg>
        </div>

        <div class="video">
          <video ref="videoCamera"
            style="margin: 0 auto;"
            :class="['videoCamera', { rotateY180: isMirror }]"
            webkit-playsinline="true" playsinline="true" preload="metadata" x-webkit-airplay="deny"
            x5-video-player-type="h5" :width="videoWidth" :height="videoHeight" autoplay>
          </video>
        </div>
        <img v-if="HkBaseFace" :src="HkBaseFace" class="captured-preview" alt="拍摄照片" />
        <canvas :class="['canvas', { rotateY180: isMirror }]" style="display: none" ref="canvasCamera" :width="videoWidth" :height="videoHeight">
        </canvas>
      </div>
      
      <div class="test_text" v-if="HkBaseFace !== ''">
        <div style="width: 20%;">
            <div v-if="isCheck"><img width="100%" :src="require('@/assets/image/检测通过.png')" alt=""></div>
            <div v-else><img width="100%" :src="require('@/assets/image/检测不通过.png')" alt=""></div>
        </div>
        <div>
          <div v-for="(item, i) in faceCodeEntityList" :style="{ color: colorList[item.status] }" :key="i" class="testTextLi">
            <van-icon name="checked" v-if="+item.status == 1"/>
            <van-icon name="clear" v-else/>
            &nbsp;
            {{item.msg}} 
            <span v-if="item.msg == '照片质量检测'">
              {{ item.value }}
              <template v-if="item.value && +item.value >= 0.72">
                (>= 0.72)通过
              </template>
              <template v-else>
                (< 0.72)未通过
              </template>
            </span>
            <span v-if="item.msg == '人像占比检测'">
                {{ item.value }}
               <template v-if="item.value && item.value >= 0.2">
                (>= 0.2)通过
              </template>
              <template v-else>
                (<0.2)未通过
              </template>
            </span>
          </div>
        </div>
      </div> 

      <van-popup v-model:show="showUserDialog" style="height:100vh;width:100%;" width="100%" title="" :show-confirm-button='false' >
        <div style="padding:6px;text-align: center;font-size: 4vw;">
          <div>
            <span>体测准考证：</span>
            <span>{{studentInfo.studentName}}</span>
            <van-image
              style="margin-top:10px;"
              width="85%"
              fit="cover"
              :src="require('@/assets/image/faceStandard.jpg')"
            />
          </div>
        </div> 
        <van-button round style="width:80%;margin:10px 10%;height:40px;" color="linear-gradient(to right, #ff6034, #ee0a24)" @click="onStepShow">
          <span>去拍照</span>
        </van-button>
      </van-popup>

      <div class="btnBox">
         <div v-if="isCheck"> 
          <van-button round type="info" style="width:200px;" @click="submitBase64Img">生成准考证</van-button>
         </div>

        <div v-else style="display: flex;text-align: center;" class="btnBox">

        <div style="width:30%;height:40px;">
          <img width="38" :src="require('@/assets/icon/返回.png')" alt="" @click="showUserDialog = true">
        </div>

        <div style="width:40%;">
          <div class="setImageDiv" @click="setImage" v-if="HkBaseFace == ''">
           <img width="100%" :src="require('@/assets/image/拍照按钮.png')" alt="" >
          </div>
          <van-button @click="reAction" color="linear-gradient(to right, #ff6034, #ee0a24)" style="width:100%;font-size:16px;" round type="info" v-else>
          &nbsp;重新拍照
          </van-button>
        </div>

        <div style="width:30%;height:40px;">
          <img width="40" :src="require('@/assets/icon/切换镜头.png')" alt="" @click="changeFacingMode">
        </div>
        </div>

      </div>
   
    </div>

  </div>
</template>

<script>
import { Toast } from 'vant'
import store from '@/store'
import { insertIntoFaceData, checkFace } from "@/api/teacher/teacherAddFaceIn.js";

export default {
  name: 'camera',
  data () {
    return {
      // 调整为适合半身照的长宽比例尺寸
      videoWidth: 300,
      videoHeight: 400,
      imgSrc: '',
      HkBaseFace: '',
      HrBaseFace: '',
      thisCancas: null,
      thisContext: null,
      thisVideo: null,
      openVideo: false,
      show: false,
      userInfo: {},
      percent: 0,
      faceCheckFlag: true,
      appeal: 0,
      appealShow: false,
      remindShow: false,
      appealContent: '',
      phoneNumber: '',
      termCode: '',
      facingMode: 'environment',
      isCheck: false,
      studentInfo: {},
      isMirror: false,
      faceCodeEntityList: {},
      colorList:['#d82121', '#2dcc00'],
      showUserDialog: true,
      dataList:[]
    }
  },
  async created () {
    if (this.$route.query.studentInfo) {
      try {
        this.studentInfo = JSON.parse(this.$route.query.studentInfo)
      } catch (e) {
        console.error('解析studentInfo失败:', e)
      }
    }
  },
  mounted () {
    this.getCompetence()
  },
  methods: {
    onStepShow () {
      this.showUserDialog = false
    },
    
    changeFacingMode () {
      if (this.facingMode == 'environment') {
        this.facingMode = 'user'
      } else if (this.facingMode == 'user') {
        this.facingMode = 'environment'
      }
      this.isMirror = !this.isMirror
      this.getCompetence()
    },

    reAction () {
      this.HkBaseFace = ''
      this.HrBaseFace = ''
      this.isCheck = false
      this.faceCodeEntityList = []
      if (this.thisVideo && this.thisVideo.parentElement) {
        this.thisVideo.parentElement.style.display = 'block'
      }
      if (this.$refs.peopleOutlineImg) {
        this.$refs.peopleOutlineImg.style.opacity = 0.8
      }
    },
    
    close () {
      this.$router.back()
    },
    
    submitBase64Img () {
      const HkBaseFace = this.HkBaseFace.replace(/^data:image\/\w+;base64,/, '')
      this.studentInfo.faceData = HkBaseFace
      insertIntoFaceData(this.studentInfo).then(res => {
        this.$notify({ type: "success", message: '操作成功！' });
        this.$router.back(-1)
      })
    },

    check () {
      const HkBaseFace = this.HkBaseFace.replace(/^data:image\/\w+;base64,/, '')
      checkFace({
        faceData: HkBaseFace,
      }).then(res => {
        console.log(res);
        this.faceCodeEntityList = res.data.faceCodeEntityList
        this.isCheck = true
        res.data?.faceCodeEntityList.forEach(el => {
          if (+el.status == 0) {
            this.isCheck = false
          }
        })
      })
    },
    
    getCompetence () {
      this.thisCancas = this.$refs.canvasCamera
      this.thisContext = this.thisCancas.getContext('2d')
      this.thisVideo = this.$refs.videoCamera
      this.thisVideo.style.display = 'block'
      
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {}
      }
      
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = (constraints) => {
          const getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia
          if (!getUserMedia) {
            return Promise.reject(new Error('getUserMedia is not implemented in this browser'))
          }
          return new Promise((resolve, reject) => {
            getUserMedia.call(navigator, constraints, resolve, reject)
          })
        }
      }
      
      if (window.stream) {
        window.stream.getTracks().forEach(track => {
          track.stop()
        })
      }
      
      const constraints = {
        audio: false,
        video: {
          sourceId: 'default',
          facingMode: this.facingMode,
          width: { ideal: 1920 },
          height: { ideal: 1080 }
        }
      }
      
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          this.thisVideo.srcObject = stream
          window.stream = stream
          this.thisVideo.play()
          this.thisVideo.onloadedmetadata = () => {
            this.thisVideo.play()
          }
        })
        .catch((err) => {
          console.error('打开摄像头失败:', err)
          this.$toast.fail('调用摄像头失败，请检查权限')
        })
    },

    // 重点修改：绘制图片解决变形扭曲问题
    setImage () {
      const vw = this.thisVideo.videoWidth; // 视频流的真实物理宽度
      const vh = this.thisVideo.videoHeight; // 视频流的真实物理高度
      const cw = this.videoWidth;   // 画布需要的宽度 (300)
      const ch = this.videoHeight;  // 画布需要的高度 (400)

      // 计算模拟 object-fit: cover 的裁剪范围，防止拉伸变形
      const videoRatio = vw / vh;
      const canvasRatio = cw / ch;
      let sx, sy, sWidth, sHeight;

      if (videoRatio > canvasRatio) {
        // 视频过宽：截取中间部分
        sHeight = vh;
        sWidth = sHeight * canvasRatio;
        sx = (vw - sWidth) / 2;
        sy = 0;
      } else {
        // 视频过高：截取中间部分
        sWidth = vw;
        sHeight = sWidth / canvasRatio;
        sx = 0;
        sy = (vh - sHeight) / 2;
      }

      // 镜像处理
      if (this.isMirror) {
        this.thisContext.translate(cw, 0)
        this.thisContext.scale(-1, 1)
      }
      
      // 使用 9 参数重载 drawImage：(视频源, 原视频起点X, 原视频起点Y, 原视频截取宽, 原视频截取高, 画布起点X, 画布起点Y, 画布宽, 画布高)
      this.thisContext.drawImage(this.thisVideo, sx, sy, sWidth, sHeight, 0, 0, cw, ch)
      
      if (this.isMirror) {
        this.thisContext.setTransform(1, 0, 0, 1, 0, 0) // 恢复状态
      }

      const base64 = this.thisCancas.toDataURL('image/jpeg', 1)
      this.HkBaseFace = base64
      this.HrBaseFace = base64
      this.check()
      if (this.thisVideo && this.thisVideo.parentElement) {
        this.thisVideo.parentElement.style.display = 'none'
      }
      if (this.$refs.peopleOutlineImg) {
        this.$refs.peopleOutlineImg.style.opacity = 0.8
      }
    },
    
    compressImage (base64, targSize, callback) {
      const that = this
      if (base64.length / 1024 < targSize) {
        callback(base64)
        return
      }
      const newImage = new Image()
      newImage.src = base64
      newImage.setAttribute('crossOrigin', 'Anonymous')
      newImage.onload = function () {
        let quality = 0.95
        const canvas = that.$refs.canvasCamera
        // 不需要在这里重新 drawImage()，因为前面已经精准裁切并画好了
        let compressedBase64 = canvas.toDataURL('image/jpeg', quality) 
        while (compressedBase64.length / 1024 >= targSize) {
          quality -= 0.05
          compressedBase64 = canvas.toDataURL('image/jpeg', quality)
        }
        callback(compressedBase64) 
      }
    },

    stopNavigator () {
      this.thisVideo.srcObject.getTracks()[0].stop()
    }
  }
}
</script>

<style lang="less" scoped>
#aiFace {
  background: #fff;
  height: 100vh;
  background-color: #000;

  .title {
    font-size: 24px;
    color: #333333;
    font-weight: 700;
    text-align: center;
    padding: 40px 0;
  }
  
  .camera-box {
    width: 300px;
    height: 400px; 
    position: relative;
    margin: 0 auto;
    overflow: hidden;
  }
  
  .video {
    width: 300px;
    height: 400px;
    margin: 0 auto;
    position: relative;
    display: flex;
    align-items: center;
    
    .videoCamera {
      margin: 0 auto;
      width: 100%;
      height: 100%;
      /* 铺满盒子避免比例拉伸变形 */
      object-fit: cover;
    }
  }

  .people-outline {
    height: 400px;
    width: 300px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    transition: opacity 0.3s;
  }

  .canvas {
    margin: 0 auto;
    width: 300px;
    height: 400px;
    background-size: 100% 100%;
  }

  .captured-preview {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 1;
  }
  
  .rotateY180 {
    transform: rotateY(180deg);
  }

  .test_text {
    display: flex;
    text-align: center;
    font-size: 4vw;
    margin-top: 30px;
    letter-spacing: 1.2px;
    .testTextLi {
      line-height: 40px;
      text-align: left;
    }
  }

  .green {
    width: 100%;
  }

  .btnBox {
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    width: 100%;
    margin-top: 20px;
    .setImageDiv {
      width: 80px;
      height: 80px;
      text-align: center;
      margin: 0 auto;
    }
  }

  .camera_outer {
    padding: 20px 0;
    .tips {
      text-align: center;
      padding: 0 20px 20px;
      width: 70%;
      margin: 0 auto;
    }
  }

  /deep/ .van-button--info,
  .van-button--default {
    width: 124px;
  }
}
</style>